(() => {
  const usRegions = new Map();
  [
    ["AL", "Alabama"],
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"],
    ["DC", "District of Columbia"],
  ].forEach(([code, name]) => {
    usRegions.set(code, name);
    usRegions.set(name.toLowerCase(), name);
  });

  const getValidatedRegion = (location) => {
    const regionName = String(location.region || "").trim().toLowerCase();
    const regionCode = String(location.region_code || "")
      .trim()
      .toUpperCase()
      .replace(/^US-/, "");

    return usRegions.get(regionName) || usRegions.get(regionCode) || "";
  };

  const cleanCity = value => {
    const city = String(value || "").trim();
    return city.length <= 60 && /^[\p{L}\p{M} .’'-]{2,}$/u.test(city) ? city : "";
  };
  const destination = (country, location, fallback, near = "Near [city]") => {
    if (!location || String(location.country_code || "").toUpperCase() !== country) return {text:fallback,level:"country"};
    if (country === "US") {
      const state = getValidatedRegion(location);
      return {text:state || fallback,level:state ? "state" : "country"};
    }
    const city = cleanCity(location.city);
    return {text:city ? near.replace("[city]",city) : fallback,level:city ? "city" : "country"};
  };
  if (typeof module !== "undefined" && module.exports) module.exports = {destination,cleanCity,getValidatedRegion};
  if (typeof document === "undefined" || window.FourPawDestination) return;
  window.FourPawDestination = true;
  const selector = "[data-fourpaw-destination-reassurance]";
  const key = "fourpaw-destination-v3";
  const lookup = async () => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(key) || "null");
      if (cached && Date.now()-cached.savedAt < 1800000) return cached.location;
    } catch (_) {}
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(),2200);
    try {
      const response = await fetch("https://get.geojs.io/v1/ip/geo.json",{credentials:"omit",referrerPolicy:"no-referrer",cache:"no-store",signal:controller.signal});
      if (!response.ok) return null;
      const raw = await response.json();
      const location = {country_code:String(raw.country_code || "").toUpperCase(),region:String(raw.region || ""),region_code:String(raw.region_code || ""),city:cleanCity(raw.city)};
      if (!/^[A-Z]{2}$/.test(location.country_code)) return null;
      try {sessionStorage.setItem(key,JSON.stringify({savedAt:Date.now(),location}));} catch (_) {}
      return location;
    } catch (_) {return null;} finally {window.clearTimeout(timer);}
  };
  const initialize = async () => {
    if (!document.querySelector(selector)) return;
    window.fourpawDestinationLookup ||= lookup();
    const location = await window.fourpawDestinationLookup;
    document.querySelectorAll(selector).forEach(element => {
      const country = element.dataset.countryCode;
      const fallback = element.dataset.countryName || element.textContent.trim();
      const result = destination(country,location,fallback,element.dataset.nearTemplate);
      const template = element.dataset.template || "[country]";
      element.textContent = template.replace("[country]",result.text);
      element.dataset.destinationLevel = result.level;
      element.title = result.level === "city" ? result.text+", "+fallback : result.text;
    });
  };
  const start = () => window.requestIdleCallback ? window.requestIdleCallback(initialize,{timeout:1200}) : window.setTimeout(initialize,100);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded",start,{once:true}); else start();
  document.addEventListener("shopify:section:load",initialize);
})();
